import { ISMT_ChuDe_DeThiIn } from "../../../../model/respone/de-thi/ISMT_ChuDe_DeThiIn";
import { IChuDeThiInActionTypes } from "../../../action-types/de-thi/de-thi-in/IChuDeThiInActions";
import { IChuDeThiInReducer } from "../../../reducer-model/de-thi/de-thi-in/IChuDeThiInReducer";
import { eReducerStatusBase } from "../../../reducer-model/eReducerStatusBase";

const iniState: IChuDeThiInReducer = {
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  chuDeThiInEditing: {} as ISMT_ChuDe_DeThiIn,
  chuDeThiIns: [],
  request: {} as any,
};

export const chuDeThiInReducer = (
  state: IChuDeThiInReducer = iniState,
  action: IChuDeThiInActionTypes
): IChuDeThiInReducer => {
  switch (action.type) {
    case "CHU_DE_THI_IN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        chuDeThiIns: [],
      };
    case "CHU_DE_THI_IN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        chuDeThiIns: action.payload,
      };
    case "CHU_DE_THI_IN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CHU_DE_THI_IN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "CHU_DE_THI_IN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "CHU_DE_THI_IN_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CHU_DE_THI_IN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "CHU_DE_THI_IN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "CHU_DE_THI_IN_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    case "CHU_DE_THI_IN_DELETE_MULTIPLE_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "CHU_DE_THI_IN_DELETE_MULTIPLE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    case "CHU_DE_THI_IN_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "CHU_DE_THI_IN_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "CHU_DE_THI_IN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        chuDeThiInEditing: action.payload,
      };
    case "CHU_DE_THI_IN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        chuDeThiInEditing: undefined,
      };
    default:
      return state;
  }
};
